module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="filter_button" tabindex=0>\n	<span class="checked_items" tabindex=0 data-title="' +
((__t = ( categoryName() )) == null ? '' : __t) +
'">\n		<p id="filter_button_access" class="accessibility"></p>\n	</span>\n</div>\n<ul class="filter_dropdown">\n	<div class="reset_filter none_selected" tabindex="0">\n		<p id="reset_filter_access" class="accessibility"></p>\n	</div>\n	<div class="category_item_region"></div>\n</ul>';

}
return __p
}